import axios from "axios";
import Cookies from "js-cookie";

const ENDPOINT_PATH =
    "https://saludnl.gob.mx/apis/cancermama/v1/login.php/";

export default {
    setUserLogged(userLogged) {
        Cookies.set("userName", userLogged.name);
        Cookies.set("userMail", userLogged.email);
        Cookies.set("userID", userLogged.id);
    },

    getUserLogged() {
        return Cookies.get("userLogged");
    },

    getUserEmailLogged() {
        return Cookies.get("userMail");
    },

    getUserIDLogged() {
        return Cookies.get("userID");
    },

    isUserLogged() {
        if (this.getUserIDLogged() != null) {
            return true;
        } else {
            return false;
        }
    },

    deleteUserLogged() {
        Cookies.remove('userName');
        Cookies.remove('userMail');
        Cookies.remove('userID');
    },

    login(email, password) {
        let axiosConfig = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        var bodyFormData = new FormData();
        bodyFormData.append("email", email);
        bodyFormData.append("passwrd", password);

        return axios.post(ENDPOINT_PATH, bodyFormData, axiosConfig)
            /*axios
              .post(ENDPOINT_PATH, bodyFormData, axiosConfig)
              .then((result) => {
                console.info("SUCCESS SEND");
                console.info(result);
                return result;
              })
              .catch((error) => {
                console.info("ERROR SEND");
                console.error(error);
                return null;
              });*/
    },
};